import { createPopper } from "@popperjs/core";
import { arrow, defaultModifiers, flip, offset, preventOverflow } from "@popperjs/core/lib/popper";
export const createPopperInstance = (reference, popper, placement = "auto") => {
    return createPopper(reference, popper, {
        placement,
        modifiers: [
            ...defaultModifiers,
            flip,
            offset,
            preventOverflow,
            arrow,
            {
                name: "preventOverflow",
                options: {
                    altAxis: true,
                    padding: 16
                }
            },
            {
                name: "offset",
                options: {
                    offset: ({ innerPlacement, innerReference }) => {
                        if (innerPlacement === "left-end" || innerPlacement === "right-end") {
                            return [innerReference.height + innerReference.y + 3, 14];
                        }
                        else if (innerPlacement === "left") {
                            return [100, 15];
                        }
                        else {
                            return [0, 5];
                        }
                    }
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: false // this will recompute popper position
                }
            }
        ]
    });
};
